var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 4.70727V3.65234H10.75V1.65234H14.75V3.65234H13.75V4.70727C15.4855 4.89912 17.0723 5.58444 18.3669 6.61981L20.0413 4.938L21.4587 6.34911L19.7813 8.03387C21.0133 9.57366 21.75 11.527 21.75 13.6523C21.75 18.6229 17.7206 22.6523 12.75 22.6523C7.77944 22.6523 3.75 18.6229 3.75 13.6523C3.75 9.01979 7.25005 5.20472 11.75 4.70727ZM12.75 20.6523C16.616 20.6523 19.75 17.5183 19.75 13.6523C19.75 9.78635 16.616 6.65235 12.75 6.65235C8.88399 6.65235 5.74998 9.78635 5.74998 13.6523C5.74998 17.5183 8.88399 20.6523 12.75 20.6523ZM13.75 14.6523V8.65234H11.75V14.6523H13.75Z",
    fill: "#B3B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.111a7749f39d1db1c898b62a4c8981f9.svg";
export { ForwardRef as ReactComponent };